import * as types from 'store/modules/hrms32e/mutation-types'
import { constLabels } from 'assets/js/constLabels.js'
import hrms32eLabels from 'assets/labels/hrms32e'
import { detail6TableMaxRowspan, hrms32eColumns } from 'assets/columns/hrms32e'
import configLabel from 'src/../config/label'
import hrms32e from 'api/hrms32e'
import swal from 'sweetalert'
import axios from 'axios'

export default {
  state: {
    labels: hrms32eLabels,
    maxRowspan: detail6TableMaxRowspan,
    columns: hrms32eColumns(),
    indexSelected: {},
    index: {
      total: 0,
      rows: []
    },
    detail: {
      index: {},
      topic: {},
      detail1: {},
      detail2: {
        tab1: {},
        tab2: {},
        tab3: {},
        tab4: {},
        tab5: {},
        tab6: {
          table1: {
            total: 0,
            rows: []
          },
          table2: {
            total: 0,
            rows: []
          },
          table3: {
            total: 0,
            rows: []
          }
        },
        tab7: {
          total: 0,
          rows: []
        }
      },
      detail3: {
        total: 0,
        rows: []
      },
      detail4: {
        total: 0,
        rows: []
      },
      detail5: {},
      detail6: {
        total: 0,
        rows: []
      }
    },
    dropdowns: {
      codedlv: {
        en: {},
        th: {}
      },
      coddglv: {
        en: {},
        th: {}
      },
      codmajsb: {
        en: {},
        th: {}
      },
      codminsb: {
        en: {},
        th: {}
      },
      codinst: {
        en: {},
        th: {}
      },
      codcount: {
        en: {},
        th: {}
      },
      flgeduc: {
        en: {},
        th: {}
      },
      typrewd: {
        en: {},
        th: {}
      },
      namsex: {
        en: {},
        th: {}
      },
      codprovr: {
        en: {},
        th: {}
      },
      coddistr: {
        en: [],
        th: []
      },
      codsubdistr: {
        en: [],
        th: []
      },
      stamarry: {
        en: {},
        th: {}
      },
      stamilit: {
        en: {},
        th: {}
      },
      codfnatn: {
        en: {},
        th: {}
      },
      codfrelg: {
        en: {},
        th: {}
      },
      codfoccu: {
        en: {},
        th: {}
      },
      codbank: {
        en: {},
        th: {}
      },
      typdoc: {
        en: {},
        th: {}
      },
      codtitle: {
        en: {},
        th: {}
      },
      flgedlv: {
        en: {},
        th: {}
      },
      flgdeduct: {
        en: {},
        th: {}
      }
    },
    response: {
      status: '',
      data: ''
    }
  },
  getters: {
    [types.GET_HRMS32E_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS32E_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    },
    [types.GET_HRMS32E_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS32E_DROPDOWNS] (state) {
      return state.dropdowns
    },
    [types.GET_HRMS32E_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS32E_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRMS32E_DETAIL_INDEX] (state) {
      return state.detail.index
    },
    [types.GET_HRMS32E_DETAIL_TOPIC] (state) {
      return state.detail.topic
    },
    [types.GET_HRMS32E_DETAIL_TAB1] (state) {
      return state.detail.detail1
    },
    [types.GET_HRMS32E_DETAIL_TAB2] (state) {
      return state.detail.detail2
    },
    [types.GET_HRMS32E_DETAIL_TAB3] (state) {
      return state.detail.detail3
    },
    [types.GET_HRMS32E_DETAIL_TAB4] (state) {
      return state.detail.detail4
    },
    [types.GET_HRMS32E_DETAIL_TAB5] (state) {
      return state.detail.detail5
    },
    [types.GET_HRMS32E_DETAIL_TAB6] (state) {
      return state.detail.detail6
    }
  },
  mutations: {
    [types.SET_HRMS32E_COLUMNS] (state, { labels, dropdowns }) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])

        let dropdownSets = [
          { key: 'typdoc', value: dropdowns.typdoc[keyLang] }
        ]
        state.columns[keyLang].detail2Tab7Table = configLabel.replaceLabelToColumns(state.columns[keyLang].detail2Tab7Table, labels[keyLang], dropdownSets)

        dropdownSets = [
          { key: 'codedlv', value: dropdowns.codedlv[keyLang] },
          { key: 'coddglv', value: dropdowns.coddglv[keyLang] },
          { key: 'codmajsb', value: dropdowns.codmajsb[keyLang] },
          { key: 'codminsb', value: dropdowns.codminsb[keyLang] },
          { key: 'codinst', value: dropdowns.codinst[keyLang] },
          { key: 'codcount', value: dropdowns.codcount[keyLang] },
          { key: 'flgeduc', value: dropdowns.flgeduc[keyLang] }
        ]
        state.columns[keyLang].detail3Table = configLabel.replaceLabelToColumns(state.columns[keyLang].detail3Table, labels[keyLang], dropdownSets)

        dropdownSets = [
          { key: 'namsex', value: dropdowns.namsex[keyLang] },
          { key: 'flgedlv', value: dropdowns.flgedlv[keyLang] },
          { key: 'codedlv', value: dropdowns.codedlv[keyLang] },
          { key: 'flgdeduct', value: dropdowns.flgdeduct[keyLang] }
        ]
        state.columns[keyLang].detail4Table = configLabel.replaceLabelToColumns(state.columns[keyLang].detail4Table, labels[keyLang], dropdownSets)
        state.columns[keyLang].detail6Table = configLabel.replaceLabelToColumns(state.columns[keyLang].detail6Table, labels[keyLang])
      }
    },
    [types.SET_HRMS32E_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRMS32E_DROPDOWNS] (state, dropdowns) {
      state.dropdowns = dropdowns
    },
    [types.SET_HRMS32E_DROPDOWNS2] (state, dropdowns) {
      state.dropdowns.coddistr = dropdowns.coddistr
      state.dropdowns.codsubdistr = dropdowns.codsubdistr
    },
    [types.SET_HRMS32E_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRMS32E_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRMS32E_DETAIL_INDEX] (state, data) {
      state.detail.index = data
    },
    [types.SET_HRMS32E_DETAIL_TOPIC] (state, data) {
      state.detail.topic = data
    },
    [types.SET_HRMS32E_DETAIL_TAB1] (state, data) {
      state.detail.detail1 = data
    },
    [types.SET_HRMS32E_DETAIL_TAB2] (state, data) {
      state.detail.detail2 = data
    },
    [types.SET_HRMS32E_DETAIL_TAB3] (state, data) {
      state.detail.detail3 = data
    },
    [types.SET_HRMS32E_DETAIL_TAB4] (state, data) {
      state.detail.detail4 = data
    },
    [types.SET_HRMS32E_DETAIL_TAB5] (state, data) {
      state.detail.detail5 = data
    },
    [types.SET_HRMS32E_DETAIL_TAB6] (state, data) {
      state.detail.detail6 = data
    },
    [types.DELETE_HRMS32E_DOCUMENTS] (state, rowIndex) {
      state.detail.detail2.tab7.rows.splice(rowIndex, 1)
    },
    [types.DELETE_HRMS32E_EDUCATION] (state, rowIndex) {
      state.detail.detail3.rows.splice(rowIndex, 1)
    },
    [types.DELETE_HRMS32E_CHILD_DATA] (state, rowIndex) {
      state.detail.detail4.rows.splice(rowIndex, 1)
    },
    [types.DELETE_HRMS32E_TRAINING_DATA] (state, rowIndex) {
      state.detail.detail6.rows.splice(rowIndex, 1)
    }
  },
  actions: {
    [types.RECEIVED_HRMS32E_DROPDOWNS_COLUMNS_LABELS] ({ state, commit }) {
      axios.all([
        hrms32e.getLabels(),
        hrms32e.getDropdowns()
      ])
      .then(axios.spread(function (responseColumnsLabels, responseDropdowns) {
        const dataDropdowns = JSON.parse(responseDropdowns.request.response)
        commit(types.SET_HRMS32E_DROPDOWNS, dataDropdowns)

        const dataColumnsLabels = JSON.parse(responseColumnsLabels.request.response)
        commit(types.SET_HRMS32E_COLUMNS, { labels: dataColumnsLabels.labels, dropdowns: dataDropdowns })
        commit(types.SET_HRMS32E_LABELS, dataColumnsLabels.labels)
      }))
      .catch((error) => {
        let message = error
        if (error.response) {
          const data = error.response.data
          message = data.response
        }
        swal({
          title: '', text: message, html: true, type: 'error'
        }, function () {
          window.onkeydown = null; window.onfocus = null; swal('')
        })
      })
    },
    [types.RECEIVED_HRMS32E_DROPDOWNS2] ({ state, commit }) {
      hrms32e.getDropdowns2()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS32E_DROPDOWNS2, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS32E_INDEX] ({ commit }, searchParams) {
      hrms32e.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS32E_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS32E_DETAIL_INDEX] ({ commit }) {
      hrms32e.getDetailIndex()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS32E_DETAIL_INDEX, data.index)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS32E_DETAIL_TOPIC] ({ commit }) {
      hrms32e.getDetailTopic()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS32E_DETAIL_TOPIC, data.topic)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS32E_DETAIL_TAB1_CREATE] ({ commit }, paramSearchDetail) {
      hrms32e.getDetailTab1Crate(paramSearchDetail)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS32E_DETAIL_TAB1, data.detail1)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS32E_DETAIL_TAB2_6_CREATE] ({ commit }, paramSearchDetail) {
      hrms32e.getDetailTab2_6Crate(paramSearchDetail)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS32E_DETAIL_TAB2, data.detail2)
          commit(types.SET_HRMS32E_DETAIL_TAB3, data.detail3)
          commit(types.SET_HRMS32E_DETAIL_TAB4, data.detail4)
          commit(types.SET_HRMS32E_DETAIL_TAB5, data.detail5)
          commit(types.SET_HRMS32E_DETAIL_TAB6, data.detail6)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS32E_DETAIL_TAB1] ({ commit }, detailParams) {
      hrms32e.getDetailTab1(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS32E_DETAIL_TAB1, data.detail1)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS32E_DETAIL_TAB2_6] ({ commit }, detailParams) {
      hrms32e.getDetailTab2_6(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS32E_DETAIL_TAB2, data.detail2)
          commit(types.SET_HRMS32E_DETAIL_TAB3, data.detail3)
          commit(types.SET_HRMS32E_DETAIL_TAB4, data.detail4)
          commit(types.SET_HRMS32E_DETAIL_TAB5, data.detail5)
          commit(types.SET_HRMS32E_DETAIL_TAB6, data.detail6)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS32E_DETAIL1_SAVE] ({ commit, dispatch }, { saveParams, searchIndex, togglePage }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms32e.postDetail1Save(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS32E_INDEX, searchIndex)
              togglePage(0)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS32E_DETAIL2_TAB1_SAVE] ({ commit, dispatch }, { saveParams, searchIndex, togglePage }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms32e.postDetail2Tab1Save(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS32E_INDEX, searchIndex)
              togglePage(0)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS32E_DETAIL2_TAB2_SAVE] ({ commit, dispatch }, { saveParams, searchIndex, togglePage }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms32e.postDetail2Tab2Save(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS32E_INDEX, searchIndex)
              togglePage(0)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS32E_DETAIL2_TAB3_SAVE] ({ commit, dispatch }, { saveParams, searchIndex, togglePage }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms32e.postDetail2Tab3Save(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS32E_INDEX, searchIndex)
              togglePage(0)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS32E_DETAIL2_TAB4_SAVE] ({ commit, dispatch }, { saveParams, searchIndex, togglePage }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms32e.postDetail2Tab4Save(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS32E_INDEX, searchIndex)
              togglePage(0)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS32E_DETAIL2_TAB5_SAVE] ({ commit, dispatch }, { saveParams, searchIndex, togglePage }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms32e.postDetail2Tab5Save(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS32E_INDEX, searchIndex)
              togglePage(0)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS32E_DETAIL2_TAB6_SAVE] ({ commit, dispatch }, { saveParams, searchIndex, togglePage }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms32e.postDetail2Tab6Save(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS32E_INDEX, searchIndex)
              togglePage(0)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS32E_DETAIL2_TAB7_SAVE] ({ commit, dispatch }, { saveParams, searchIndex, togglePage }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms32e.postDetail2Tab7Save(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS32E_INDEX, searchIndex)
              togglePage(0)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS32E_DETAIL3_SAVE] ({ commit, dispatch }, { saveParams, searchIndex, togglePage }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms32e.postDetail3Save(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS32E_INDEX, searchIndex)
              togglePage(0)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS32E_DETAIL4_SAVE] ({ commit, dispatch }, { saveParams, searchIndex, togglePage }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms32e.postDetail4Save(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS32E_INDEX, searchIndex)
              togglePage(0)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS32E_DETAIL5_SAVE] ({ commit, dispatch }, { saveParams, searchIndex, togglePage }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms32e.postDetail5Save(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS32E_INDEX, searchIndex)
              togglePage(0)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS32E_DETAIL6_SAVE] ({ commit, dispatch }, { saveParams, searchIndex, togglePage }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms32e.postDetail6Save(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS32E_INDEX, searchIndex)
              togglePage(0)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS32E_CANCEL] ({ commit, dispatch }, { cancelParams, searchIndex }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmCancel'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel'),
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms32e.postCancel(cancelParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS32E_INDEX, searchIndex)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms32e/index.js